// extracted by mini-css-extract-plugin
export var noSpinners = "_mw-6";
export var percentageInput = "_mw-7";
export var variantColor1 = "_mw-0";
export var variantColor2 = "_mw-1";
export var variantColor3 = "_mw-2";
export var variantColor4 = "_mw-3";
export var variantColor5 = "_mw-4";
export var variantColor6 = "_mw-5";